import actions from './actions';

const initialState = {
    montajes:       [],
    currentMontaje: null,
    previewItems:   [],
    loading:        false,
};

export default function MontajesReducer(state = initialState, action) {
    switch (action.type) {
        case actions.SET_LOADING:
            return { ...state, loading: action.value };
        case actions.GET_MONTAJES_SUCCESS:
            return { ...state, montajes: action.payload, loading: false };
        case actions.GET_MONTAJE_SUCCESS:
            return { ...state, currentMontaje: action.payload, loading: false };
        case actions.CREATE_MONTAJE_SUCCESS:
            return { ...state, montajes: [action.payload, ...state.montajes], loading: false };
        case actions.UPDATE_MONTAJE_SUCCESS:
            return {
                ...state,
                montajes: state.montajes.map(m => m._id === action.payload._id ? action.payload : m),
                currentMontaje: action.payload,
                loading: false,
            };
        case actions.ANULAR_MONTAJE_SUCCESS:
            return {
                ...state,
                montajes: state.montajes.map(m => m._id === action.id ? { ...m, estado: 'ANULADO' } : m),
                loading: false,
            };
        case actions.PREVIEW_CONSUMO_SUCCESS:
            return { ...state, previewItems: action.payload, loading: false };
        case actions.CONFIRMAR_MONTAJE_SUCCESS:
            return {
                ...state,
                montajes: state.montajes.map(m => m._id === action.id ? { ...m, estado: 'CONFIRMADO' } : m),
                loading: false,
            };
        default:
            return state;
    }
}
